import PropTypes from 'prop-types'
import React from 'react'
import { rtlConvertInline, css } from 'lib/paypalphrodite'
import styles from './funding-source.styles'
import {
  buildFundingSourceDisplayName,
  generateSourceLogoUrls,
} from '../utils/funding-option-utils'

export default class DisallowedFundingSource extends React.Component {
  static propTypes = {
    fundingOption: PropTypes.shape({
      instrument_type: PropTypes.string.isRequired,
    }),
    isCFPBEnabledCountry: PropTypes.bool,
    isCardArtEnabled: PropTypes.bool,
    userAccountType: PropTypes.string,
    isRTL: PropTypes.bool,
    index: PropTypes.number,
  }

  render() {
    const {
      index,
      fundingOption,
      isCFPBEnabledCountry,
      userAccountType,
      isCardArtEnabled,
    } = this.props
    const title = buildFundingSourceDisplayName(
      fundingOption,
      isCFPBEnabledCountry,
      userAccountType,
      isCardArtEnabled
    )
    const radionBtnStyle = this.props.isRTL
      ? styles.radioButtonTextRTL
      : styles.radioButtonText
    const cardArtStyles = rtlConvertInline(styles.fundingOptionLogo)
    return (
      <li>
        <div
          className={css(
            rtlConvertInline(styles.fundingOptionWrapper),
            styles.greyedOut
          )}
        >
          <div
            className={`vx_radio ${rtlConvertInline(
              css(styles.radioButtonWrapper)
            )}`}
          >
            <input
              id={index}
              name="fundingOption"
              type="radio"
              value={index}
              disabled={true}
            />
            <label
              htmlFor={index}
              className={css(
                rtlConvertInline(styles.radioButton),
                rtlConvertInline(styles.forceDisplayBlock),
                rtlConvertInline(styles.disabledLabel)
              )}
            >
              <img
                alt=""
                className={css(cardArtStyles)}
                data-testid="disallowed-card-art"
                src={generateSourceLogoUrls(
                  fundingOption,
                  isCFPBEnabledCountry,
                  userAccountType,
                  isCardArtEnabled
                )}
                width={50}
              />
              <p
                className={css(
                  rtlConvertInline(radionBtnStyle),
                  rtlConvertInline(styles.preventIncorrectLabelWrapWithLogo)
                )}
                data-nemo={`disallowed-choice-FI-Name-${index}`}
              >
                {title}
              </p>
            </label>
          </div>
        </div>
        <hr className={css(rtlConvertInline(styles.lineSeparator))} />
      </li>
    )
  }
}
